export const getUrlParams = (key: string): string | null => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has(key)) return searchParams.get(key);

    return null;
};
